import { IAdaptedProviderBundlesResponse, IAdaptedSearchProviderResponse, IFacilityAssociatedPhysicians, IListProviderBundles, ISearchProviderResponse } from "../interfaces";

export const adaptSearchProviderResponse = (response: ISearchProviderResponse): IAdaptedSearchProviderResponse => {
const { type } = response;
const isFacility = type === 'FACILITY';

const taxonomyName:string | null = response.taxonomies && response.taxonomies.length ? response.taxonomies[0].description : null;
const miles: number = response.distanceKM ? Number((response.distanceKM * 0.621).toFixed(2)) : 0;

  return {
    id: response.id,
    code: response.code,
    npi: response.npi,
    serviceMode: response.serviceMode,
    distance: miles,
    ...(isFacility && {
        facility: {
            displayName: response.facilityBasicInfo?.displayName,
            businessName: response.facilityBasicInfo?.businessName,
            address: {
                addressLine1: response.addressLine1,
                addressLine2: response.addressLine2,
                city: response.city,
                state: response.state,
                zip: response.zip,
            },
            primaryTaxonomy: [{
                name: taxonomyName
            }]
        }
    }),
    ...(!isFacility && {
        physician: {
            fullName: `${response.physicianBasicInfo?.firstName} ${response.physicianBasicInfo?.lastName}`,
            firstName: response.physicianBasicInfo?.firstName,
            lastName: response.physicianBasicInfo?.lastName,
            primaryTaxonomy: [{
                name: taxonomyName
            }],
            address: {
                addressLine1: response.addressLine1,
                addressLine2: response.addressLine2,
                city: response.city,
                state: response.state,
                zip: response.zip,
            }
        }

    }),
    latitude: response.latitude,
    longitude: response.longitude,
  };
};


export const adaptProviderBundlesResponse = (response: IListProviderBundles): IAdaptedProviderBundlesResponse  => {
    return {
        id: response.id,
        code: response.code,
        providerCode: response.providerCode,
        bundleCode: response.bundleCode,
        createdAt: response.createdAt,
        updatedAt: response.updatedAt,
        bundleName: response.bundle.bundleName,
        displayName: response.bundle.displayName,
        description: response.bundle.description,
    }
}